<template>
    <q-page class="q-pa-md fullscreen-height">
        <div class="row q-pt-md q-col-gutter-md" style="height: 100%; overflow-y: auto;">
            <!-- Columna izquierda: solo aparece si mostrarFormulario es true -->

            <div v-if="mostrarFormulario" class="col-md-4 col-12">
                <q-card class="q-pa-md">
                    <q-form @submit="guardarFormulario">
                        <div class="text-h6 q-mb-md">Nuevo Modelo</div>
                        <q-input dense v-model="formulario.modelo" outlined label="Nombre del Modelo" class="q-mb-md"
                            required />
                        <q-select outlined v-model="marca" :options="itemsMarcas" label="Marca" class="q-mb-md"
                            option-label="marca" dense required />
                        <!-- <q-input prefix="$" dense v-model="formulario.precio" outlined label="Precio" class="q-mb-md"
                            required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" /> -->
                        <q-input dense v-model="formulario.anio" outlined label="Año" class="q-mb-md" required />
                        <q-input dense v-model="formulario.color" outlined label="Color" class="q-mb-md" required />
                        <q-input dense v-model="formulario.tipovehiculo" outlined label="Tipo de Vehiculo"
                            class="q-mb-md" required />
                        <q-input dense v-model="formulario.version" outlined label="Versión" class="q-mb-md" required />
                        <q-file v-model="imagen" dense outlined label="Imagen del Modelo" class="full-width">
                            <!-- <q-file dense v-model="imagen" outlined label="URL Imagen" class="q-mb-md"> -->
                            <template v-slot:after>
                                <q-btn color="primary" round dense flat icon="mdi-plus" @click="agregarImagen()" />
                            </template>
                        </q-file>
                        <q-carousel v-if="formulario.imagenes && formulario.imagenes.length > 0" swipeable animated
                            v-model="slide" thumbnails infinite height="250px">
                            <q-carousel-slide v-for="(img, index) in formulario.imagenes" :key="index" :name="index + 1"
                                :img-src="img.imagBase64" />
                            <template v-slot:control>
                                <q-carousel-control position="top-right" :offset="[18, 18]">
                                    <q-btn push round dense color="red" text-color="white" icon="mdi-delete"
                                        @click="eliminarImg()" />
                                </q-carousel-control>
                            </template>
                        </q-carousel>
                        <div class="row justify-between">
                            <q-btn outline icon="mdi-content-save" v-if="formulario._id != ''" label="Editar"
                                color="primary" type="submit" class=" q-mt-md q-mr-sm" />
                            <q-btn outline icon="mdi-content-save" v-else label="Guardar" color="primary" type="submit"
                                class="q-mt-md q-mr-sm" />
                            <q-btn outline icon="mdi-close" label="Cerrar" color="negative" class="q-mt-md"
                                @click="mostrarFormulario = false" />
                        </div>
                    </q-form>
                </q-card>
            </div>

            <!-- Columna derecha: tabla ocupa más espacio si no hay formulario -->
            <div :class="mostrarFormulario ? 'col-md-8 col-12' : 'col-12'">
                <q-table dense title="Modelos" class="shadow-1" :data="items" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <div class="row">
                            <q-select class="q-mr-sm q-my-md" style="width: 200px;" outlined v-model="marcaSelect"
                                :options="itemsMarcasSelect" label="Marca" option-label="marca" dense required />
                            <q-btn outline color="primary" icon="mdi-refresh" label="Consultar" @click="GetModelos()"
                                no-caps class="q-mr-sm q-my-md" />
                            <q-btn outline color="primary" class="q-my-md" icon="mdi-plus" label="Nuevo"
                                @click="nuevoItem()" />
                        </div>
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="marca" :props="props" @click="verItem(props.row)">{{ props.row.marca }}</q-td>
                            <q-td key="modelo" :props="props" @click="verItem(props.row)">{{ props.row.modelo }}</q-td>
                            <!-- <q-td key="precio" :props="props" @click="verItem(props.row)">{{
                                FormatCurrency(props.row.precio) }}</q-td> -->
                            <q-td key="anio" :props="props" @click="verItem(props.row)">{{ props.row.anio }}</q-td>
                            <q-td key="color" :props="props" @click="verItem(props.row)">{{ props.row.color }}</q-td>
                            <q-td key="tipovehiculo" :props="props" @click="verItem(props.row)">{{
                                props.row.tipovehiculo }}</q-td>
                            <q-td key="version" :props="props" @click="verItem(props.row)">{{ props.row.version
                            }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: false,
            mostrarFormulario: false,
            slide: 1,
            columns: [
                { name: 'marca', label: 'Marca', field: 'marca', align: 'center', sortable: true },
                { name: 'modelo', label: 'Modelo', field: 'modelo', align: 'center', sortable: true },
                // { name: 'precio', label: 'Precio', field: 'precio', align: 'right', sortable: true },
                { name: 'anio', label: 'Año', field: 'anio', align: 'center', sortable: true },
                { name: 'color', label: 'Color', field: 'color', align: 'center', sortable: true },
                { name: 'tipovehiculo', label: 'Tipo de Vehiculo', field: 'tipovehiculo', align: 'center', sortable: true },
                { name: 'version', label: 'Version', field: 'version', align: 'center', sortable: true },
            ],
            formulario: {
                _id: '',
                _id_marca: '',
                modelo: '',
                precio: 0,
                anio: '',
                color: '',
                tipovehiculo: '',
                version: '',
                imagenes: []
            },
            imagen: null,
            initialPagination: {
                sortBy: 'modelo',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },

            marca: {
                _id: '',
                marca: ''
            },

            marcaSelect: {
                _id: 'Todos',
                marca: 'Todos'
            },
            itemsMarcasSelect: []
        };
    },
    computed: {
        items() {
            return this.$store.state.auth.listModelosStore;
        },
        itemsMarcas() {
            return this.$store.state.auth.listMarcasStore;
        }
    },
    created() {
        this.GetModelos();
        this.GetMarcas();
    },
    methods: {
        nuevoItem() {
            this.mostrarFormulario = true
            this.formulario = {
                _id: '',
                _id_marca: '',
                modelo: '',
                precio: 0,
                anio: '',
                color: '',
                tipovehiculo: '',
                version: '',
                imagenes: []
            }
        },
        verItem(item) {
            this.mostrarFormulario = true
            this.formulario = item

            this.marca = this.itemsMarcas.find(x => x.marca == item.marca)
            console.log(this.marca)
        },
        async agregarImagen() {
            let archivo = this.imagen

            let imagen = {
                imagBase64: await this.convertirABase64(archivo),
                nombre: archivo.name,
                ruta: '',
            }
            this.formulario.imagenes.push(imagen)
            this.imagen = null
        },
        eliminarImg(item) {
            const index = this.slide - 1;
            if (index >= 0 && index < this.formulario.imagenes.length) {
                this.formulario.imagenes.splice(index, 1);
                if (this.slide > this.formulario.imagenes.length) {
                    this.slide = this.formulario.imagenes.length || 1;
                }
            }
        },
        async GetModelos() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaModelosxMarca/' + this.marcaSelect._id)
                console.log(respuesa)
                this.$store.state.auth.listModelosStore = respuesa.data
                this.loading = false

            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        async guardarFormulario() {
            this.formulario.id_marca = this.marca._id
            try {
                let respuesa = await axios.post('Autos/AltaModelos/', this.formulario)
                console.log(respuesa)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                this.formulario._id = respuesa.data._id
                this.formulario.marca = this.marca.marca
                this.$store.state.auth.listModelosStore.push(this.formulario)
                this.mostrarFormulario = false
            } catch (error) {
                console.log(error)
            }
        },

        async GetMarcas() {
            try {
                let respuesa = await axios.get('Autos/GetListaMarcas/')
                console.log(respuesa)
                this.$store.state.auth.listMarcasStore = respuesa.data
                this.itemsMarcasSelect = [...respuesa.data]
                this.itemsMarcasSelect.unshift({ _id: 'Todos', marca: 'Todos' })

            } catch (error) {
                console.log(error)
            }
        },
        FormatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
    }
};
</script>
<style>
.cuadrado-img img {
    object-fit: contain;
    background-color: white;
}

.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}
</style>
